<template>
    <div>
        <h2 class="page-title mb-4">
            What's new?
        </h2>
        <h4 class="fw-semi-bold">August 30, 2020</h4>
        <b-row class="mt-4">
          <b-col xs='12' sm='12' md='12'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Custom Tasks feature released!</h5>
                <p><span class="fw-semi-bold">We introduced Your Tasks to give you the following benefits:</span> </p>
                <ul class="bug-fixes">
                  <li><p>Keeping your team in on the conversation by tagging them</p></li>
                  <li><p>Instantly <mark># tagging</mark> patients to your Tasks via Smart Search</p></li>
                  <li><p>Adding Contextual Data to your Tasks via seamless integration with Open Dental</p></li>
                  <li><p>Taking quick actions on the tasks</p></li>
                </ul>
            </b-card>
            <b-card-img :src="taskPage" alt="Custom Tasks integration with Open Dental" class="rounded-0 mt-2" style="max-width: 1000px;"></b-card-img>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='6'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">Task Details Panel</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                
                <p><span class="fw-semi-bold">Open Task Details panel by Clicking on the individual tasks:</span> </p>
                <ul class="bug-fixes">
                  <li><p>Edit the <span class="fw-semi-bold">task text</span></p></li>
                  <li><p>Change who the task is <span class="fw-semi-bold">assigned to</span> and task <span class="fw-semi-bold">due date</span></p></li>
                  <li><p>Attaching <span class="fw-semi-bold">Wiki Pages</span> (coming soon)</p></li>
                  <li><p>View / Leave <span class="fw-semi-bold">Comments</span> for your team members to review</p></li>
                </ul>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card-img :src="taskDetails" alt="Custom Tasks integration with Open Dental" class="rounded-0 mt-2" style="max-width: 600px;"></b-card-img>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='6'>
           <b-card class="border-0">
                <h5 class="fw-semi-bold ml-4">New Feature</h5>              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Deleting a Patient from custom patient lists</h5>
                <ul class="bug-fixes">
                  <li><p>Once you've added a patient to a <mark>Custom List</mark> (either Overdue Recall or Unscheduled Tx), now you're able to <span class="fw-semi-bold">remove the patient from the list</span>, so they may be added onto another list.</p>
                  <p><span class="fw-semi-bold">Remember</span>, by deleting a patient from the list, you DO NOT lose any data. You're simply removing the patient from this list. All of the call data is maintained and can be accessed from the Master List pages.</p></li>
                </ul>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card-img :src="deletePatient" alt="Deleting a Patient from Custom Patient List created from Open Dental" class="rounded-0 mt-2" style="max-width: 600px;"></b-card-img>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <b-row class="mt-4">
          <b-col xs='12' sm='12' md='12'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Teamio How-to Resources Released!</h5>
                <p><span class="fw-semi-bold">We've released the following Videos to help you use Teamio, and will continue to add videos to build out our library!</span> </p>
                <ul class="bug-fixes">
                  <li><p><mark>Getting Started:</mark> <a href="https://teamio.app/help/build-your-hygiene-schedule-with-teamio/" target="_blank"> Video 1 – Using Overdue Recall System with Teamio to build your Hygiene Schedule</a> </p></li>
                  <li><p><mark>Getting Started:</mark> <a href="https://teamio.app/help/following-up-on-overdue-recall-patient-2/" target="_blank"> Video 2 – Making a Follow-up Attempt on an Overdue Recall Patient</a></p></li>
                  <li><p><mark>Patient Profile:</mark> <a href="https://teamio.app/help/quick-search-to-patient-profile/" target="_blank"> Using Quick Search to follow-up with Patients from their Profile</a></p></li>
                  <li><p><mark>Unscheduled Treatment:</mark> <a href="https://teamio.app/help/unscheduled-treatment-master-list/" target="_blank"> Understanding the Unscheduled Treatment “Master List” screen</a></p></li>
                  <li><p><mark>Unscheduled Treatment:</mark> <a href="https://teamio.app/help/unscheduled-treatment-filters/" target="_blank"> Using Filters for looking up Patients that fit a specific criteria</a></p></li>
                  <li><p><mark>Unscheduled Treatment:</mark> <a href="https://teamio.app/help/creating-custom-unscheduled-tx-lists/" target="_blank"> Working with Lists: Creating Custom Lists</a></p></li>
                  <li><p><mark>Overdue Recall:</mark> <a href="https://teamio.app/help/creating-overdue-recall-list-by-provider/" target="_blank"> Creating a List of Patients by Specific Provider</a></p></li>
                </ul>
            </b-card>
            <b-card-img :src="teamioHowTo" alt="Custom Tasks integration with Open Dental" class="rounded-0 mt-2" style="max-width: 700px;"></b-card-img>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <h4 class="fw-semi-bold">August 21, 2020</h4>
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='6'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                Improvements to Patient Profile
              </h4>
              <hr />
              <ul class="bug-fixes">
                <li><p>Added <span class="fw-semi-bold">Status Column</span> to Existing Follow-ups on <span class="fw-semi-bold">Patient Profile</span></p></li>
                <li><p>Added <span class="fw-semi-bold">Past Due indicator (red dot)</span> to the <span class="fw-semi-bold">Due Date column</span> (similar to other pages)</p></li>
              </ul>
            </b-card>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <h4 class="fw-semi-bold">August 16, 2020</h4>
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='6'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Introduced Default Providers for Unscheduled and Overdue Recall pages!</h5>
                <p>For offices with multiple providers, you can change the default provider in the <span class="fw-semi-bold">Settings page</span>.  </p>
                <p>Instead of constantly changing the Provider filter on the Overdue recall and Unscheduled Tx pages, since there's now a default provider set, the list will load patients for the default provider listed.</p>
            </b-card>
          </b-col>
          <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                Bug fixes & improvements
              </h4>
              <hr />
              <ul class="bug-fixes">
                <li><p><b-badge class="mr-xs" variant="warning" pill>Optimization</b-badge>Introduced <span class="fw-semi-bold">composite indexes</span> on the databases for Query Optimization to speed up data loading on the front-end.</p></li>
              </ul>
              <ul class="bug-fixes">
                <li><p><b-badge class="mr-xs" variant="danger" pill>Bug</b-badge>For overdue recall, some offices were not able to pull up patients for their providers.</p>
                <p>The data from within Open Dental was different from the list on Teamio. After a bit of one-on-one troubleshooting, it turns out some offices are using custom description for Recall types - such as "TMJ Recall", "Perio re-evals", "Perio-Restorative recalls", etc.</p></li>
                <li><p><b-badge class="mr-xs" variant="success" pill>Fix</b-badge>Fixed this by pulling up our Recall Lists by matching to the most common <span class="fw-semi-bold">Procedure Codes for Recall (D4910, D1110, D1120)</span>, instead of pulling up by Recall Description!</p></li>
              </ul>
             
            </b-card>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <h4 class="fw-semi-bold">August 10, 2020</h4>
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='6'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Initiate a follow-up directly from the Patient Profile!</h5>
                <p>Now you can quickly jump to their profile and set the follow up to begin on a certain day. </p>
                <p>If you have a patient in mind that you'd like to start following up on, it’s easier to jump to their <span class="fw-semi-bold">Profile Page through quick search</span> and set the follow-up!</p>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card-img :src="initiateFromProfile" alt="Initiate a follow-up directly from the Patient Profile!" class="rounded-0" style="max-width: 500px;"></b-card-img>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col xs='12' sm='12' md='12'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Accessing existing follow-ups that need to be done for a patient</h5>
                <p>So as of now, you were not able to take ANY action from the patient’s profile. </p>
                <p>From your feedback after talking to some of the team members one-on-one, we found out that your team was constantly looking up patients up through our quick search to go to the <span class="fw-semi-bold">Patient’s Profile</span> – but are not able to take any ACTION!</p>
            </b-card>
            <b-card-img :src="existingFromProfile" alt="Initiate a follow-up directly from the Patient Profile!" class="rounded-0 mt-2" style="max-width: 800px;"></b-card-img>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <h4 class="fw-semi-bold">July 30, 2020</h4>
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='6'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Overdue Recall filter of 2/x year cleaning</h5>
                <p>We’ve introduced this filter to only show patients whose insurance plan allows at least 2 preventive visits per year, and NOT have an explicit preventive frequency of every 6 months. </p>
                <p>This should make it easier for your scheduler responsible for following up with patients for overdue recall to only contact patients who are allowed an additional cleaning before the year is over.</p>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card-img :src="frequencyFeature" alt="Overdue Recall filter of 2/x year cleaning" class="rounded-0" style="max-width: 500px;"></b-card-img>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
          <b-row class="mt-4">
           <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                July 20, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <ul class="bug-fixes">
                <li><p>Increased the length of maximum characters to display for Insurance Name before the ...more.. link is clicked on the <span class="fw-semi-bold">Unscheduled Treatment</span> page. This was more annoying than anything to have to click on the "more" link to display the full insurance name. </p>
                </li>
                <li><p><span class="fw-semi-bold">Reduced the amount of Data being displayed for Outstanding Claims and Outstanding Pre-Authorizations:</span> Instead of showing the last 18 months of data, only pending claims / pre-authorizations from last six months are shown now.</p></li>
              </ul>
              <ul class="bug-fixes">
                <li><p><b-badge class="mr-xs" variant="danger" pill>Bug</b-badge>On the <span class="fw-semi-bold">Patient Profile page</span>, any non-recall appointments that are shown included procedures that were treatment planned, but were NOT scheduled.</p></li>
                <li><p><b-badge class="mr-xs" variant="success" pill>Fix</b-badge>Changed how we pulled data to show TRUE appointments, meaning not only were procedures treatment planned, but were ALSO SCHEDULED!</p></li>
              </ul>
            
            </b-card>
          </b-col>
          <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                July 17, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <ul class="bug-fixes">
                <li><p><b-badge class="mr-xs" variant="danger" pill>Bug</b-badge> Scheduled Appointments showed incomplete past appointments from Open Dental (in cases where appointments were NOT marked completed), or in some cases where offices were creating "fake" appointments for patient notes. Regardless, when a patient is being followed-up on, there isn't a need to view PAST INCOMPLETE appointments.</p></li>
                <li><p><b-badge class="mr-xs" variant="success" pill>Fix</b-badge>Wherever Scheduled Appointments are displayed on Teamio, past appointments will NOT be shown. Only incomplete appointments from today and future dates will be shown!</p></li>
              </ul>
            
            </b-card>
          </b-col>
          <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                July 15, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <b-badge class="mr-xs" variant="default" pill>Outstanding Claim Custom Follow-up Date</b-badge>
              <p>Once an outstanding claim was followed up on, it was set to be followed-up with every 7 days thereafter.  </p>
              <p>It was requested by few team members to allow for custom follow-up date to be set for subsequent follow-ups. Therefore, we introduced this feature to have the team members set when the claim should be followed-up on again.</p>
              <!--
              <ul class="bug-fixes">
                <li><p>Fixed a bug where on the Overdue Recall Settings page, an error was occuring when changing the accountable person.</p></li>
                <li><p>Fixed a bug where if someone goes to a page directly (having logged in before) it wasn't loading the navigation properly</p></li>
                <li><p>Fixed a bug where there was a timeout issue due to the amount of data being processed for Aging page, especially for developing the Pie Charts showing the 30-60-90 day Aging $$$.</p></li>
              </ul>
              -->
            
            </b-card>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <h4 class="fw-semi-bold">July 12, 2020</h4>
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='6'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Setting Initial Follow-up Date from Lists</h5>
                <p>Now you can set a custom date to START following up with a patient. </p>
                <p>Instead of just having the Patient Follow-up Status being displayed as "Not set" - now you can click the button and immediately set a custom follow-up date!</p>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card-img :src="notSetFollowUp" alt="Setting Initial Follow-up Date" class="rounded-0"></b-card-img>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <h4 class="fw-semi-bold">June 30, 2020</h4>
        <b-row class="mt-4">
          <b-col xs='12' sm='12' md='12'>
          <b-card class="border-0">
           
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Custom Reporting for Team Insights</h5>
                <p>Up to this point, Team Insights only gave you data for Today, Week To Date, and Month to Date (current month).</p>
                <p class="fw-semi-bold"><em>What happens if you want historical data spanning months or over a year?</em></p>
                <p>That's why we introuduced Custom Reports where you can pull up data by Month & Year.</p>

            </b-card>
          </b-col>
        </b-row>
         <b-row class="mt-4">
          <b-col xs='12' sm='8' md='8'>
           <b-card class="mb-xlg border-0" :style="{ position: 'relative' }"
           :img-src="customReports1" img-alt="Team Insights Custom Reports" img-bottom
           >
                <p><i class="glyphicon text-warning glyphicon-ok  mr-2" style="font-size: 20px;"></i>Custom reports make it easy for measuring team performance over time</p>
                <p><i class="glyphicon text-warning glyphicon-ok  mr-2" style="font-size: 20px;"></i>See WHOSE follow-ups turn into <span class="fw-semi-bold"><em>scheduled appointments</em></span> or <span class="fw-semi-bold"><em>Claims getting paid</em></span>.</p>
                <p><i class="glyphicon text-warning glyphicon-ok  mr-2" style="font-size: 20px;"></i>Helps you find out WHERE your team needs improvement based on real data!</p>
            </b-card>
          </b-col>
          <b-col xs='12' sm='4' md='4'>
           <b-card class="mb-xlg border-0" :style="{ position: 'relative' }"
           :img-src="teamInsightsCustomReportsUnscheduled" img-alt="Team Insights Custom Reports" img-bottom
           >
              <p><span class="fw-semi-bold">Instant view on your ROI from follow-ups:</span> View Scheduled Appointments from follow-ups completed by your team members.</p>
            </b-card>
          </b-col>

        </b-row>
       
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='6'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Patient Billing Type Filter</h5>
                <p>When following up with patients for balances, the <span class="fw-semi-bold">Billing Type filter</span> allows you to show patients with Standard Account, or other billing types you have set up on OpenDental.</p>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card-img :src="patientBillingFilter" alt="Image" class="rounded-0"></b-card-img>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <h4 class="fw-semi-bold">June 27, 2020</h4>
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='6'>
           <b-card class="border-0">
              <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Deleting a Custom List of Patients</h5>
                <p>Now you can Delete a custom list you've created. </p>
                <p>It does not delete patient data, it simply removes the list, so those same patients can be put on another list!</p>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card-img :src="deletePatientCustomList" alt="Deleting a Custom List" class="rounded-0"></b-card-img>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <b-row class="mt-4">
          <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                June 25, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <ul class="bug-fixes">
                <li><p><b-badge class="mr-xs" variant="success" pill>Bug Fix</b-badge> Fixed a bug on Patient Balances master list where quick filtering by patient search wasn't working properly. It was return zero results all the time. </p></li>
                <li><p><b-badge class="mr-xs" variant="success" pill>Bug Fix</b-badge> When adding patients to an existing list of Unscheduled treatment, fixed a bug when it was failing to delete the patients from the pop-over prior to saving the list.</p></li>
                <li><p>Moved the General tab of <span class="fw-semi-bold">Settings page</span> to last, so users can quickly get to the other important tabs first.</p></li>
                <li><p>Moved the <span class="fw-semi-bold">Aging Pie Charts showing 30-60-90 data</span>, and Patient Balance and Insurance Pending $ amount data to a separate reporting page. This is to reduce the load time on the Aging page where team members are focusing on making outbound calls to follow up with Outstanding claims.</p></li>
              </ul>
            
            </b-card>
          </b-col>
          <b-col xs='12' sm='6' md='8'>
            <b-card class="mb-xlg border-0" :style="{ position: 'relative' }"
           :img-src="teamInsightsCustomReportsFilter" style="max-width: 500px;" img-alt="Team Insights Custom Reports" img-bottom
           >
              <h4 class="fw-semi-bold ml-4">June 23, 2020 - New Feature</h4>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Custom Reporting for Team Insights</h5>
              <p>Started working on Custom Reports for Team Insights</p>
            </b-card>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <b-row class="mt-4">
           <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                June 20, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <ul class="bug-fixes">
                <li><p>Changed the order on <span class="fw-semi-bold">Team dashboard</span> for how tasks appear: </p>
                    <p>Completed tasks were displayed first, followed by pending (not completed tasks), followed by tasks that are due today which had a "due today" red tag displayed.</p>
                    <p><span class="fw-semi-bold">Upon one of the offices's request</span> who are making a good number of outbound calls, decided to move the "Due Today" tasks to the top, follwed by completed tasks, followed by incomplete ("late") tasks in the end.</p>
                </li>
                <li><p><b-badge class="mr-xs" variant="success" pill>Bug Fix</b-badge>When adding patients to an existing list of Unscheduled treatment, fixed a bug when it was failing to delete the patients from the pop-over prior to saving the list.</p></li>
              </ul>
            
            </b-card>
          </b-col>
          <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                June 15, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <ul class="bug-fixes">
                <li><p><b-badge class="mr-xs" variant="danger" pill>Bug</b-badge> If patient is being followed up on for unscheduled treatment, and they schedule an appointment - "Scheduled" status is displayed in their call master list. Now, if the appointment is either Broken or Sent to unscheduled list, it does not account for this "Scheduled" status of the appointment and patient is not able to be followed up on</p></li>
                <!--<li><p><span class="text-danger fw-semi-bold">Bug</span>: If patient is being followed up on for unscheduled treatment, and they schedule an appointment - "Scheduled" status is displayed in their call master list. Now, if the appointment is either Broken or Sent to unscheduled list, it does not account for this "Scheduled" status of the appointment and patient is not able to be followed up on</p></li>-->
                <li><p><b-badge class="mr-xs" variant="success" pill>Fix</b-badge> Fixed the bug by implementing a check in the back-end for checking if the appointment is either broken or being sent to unscheduled list, then we check if patient has a "scheduled" status. If they do, the task is purged and their status is "reset" back to "Not called" w/ the follow-up action plan set to "Not set".</p></li>
              </ul>
            
            </b-card>
          </b-col>
          <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                June 13, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <b-badge class="mr-xs" variant="default" pill>Appointment Completion Automation</b-badge>
              <p>Fixed a bug where upon marking an appointment completed in OpenDental, if the patient was being followed up on for unscheduled treatment, then it would create future follow up tasks in the number equal to the procedures attached to the appointment. </p>
              <p>For example, if patient came in for 2 fillings, and they were being followed up on for unscheduled treatment, upon marking the appointment complete, it would create a follow up task TWO times. This was the bug where our automation kicked off as many times as the number of procedures attached to the completed appointment.</p>
              <!--
              <ul class="bug-fixes">
                <li><p>Fixed a bug where on the Overdue Recall Settings page, an error was occuring when changing the accountable person.</p></li>
                <li><p>Fixed a bug where if someone goes to a page directly (having logged in before) it wasn't loading the navigation properly</p></li>
                <li><p>Fixed a bug where there was a timeout issue due to the amount of data being processed for Aging page, especially for developing the Pie Charts showing the 30-60-90 day Aging $$$.</p></li>
              </ul>
              -->
            
            </b-card>
          </b-col>
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <div><h4 class="mb mt-xs fw-semi-bold">June 11, 2020</h4></div>
        <b-row>
           <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <hr />
              <ul class="bug-fixes">
                <li><p>Fixed a bug of scheduled patient appointment data not showing up on Team Insights when a status of "Appointment Scheduled" is slected as the first attempt. Meaning, patient ended up scheduling on the first attempt to follow up.</p></li>
                <li><p>Did the same as above for the rest of the appointment based follow-ups.</p></li>
                <li><p>Enlarged the size of the textbox for entering longer follow up notes.</p></li>
                <li><p>Moved Communication Log View box up further while trying to make an attempt - to prevent the constant scrolling to the bottom of the page.</p></li>
              </ul>
            
            </b-card>
          </b-col>
          <b-col xs='12' sm='6' md='4'>
           <b-card class="mb-xlg border-0" :style="{ position: 'relative' }"
           :img-src="list1" img-alt="Card image" img-bottom
           >
           
                <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Adding a Patient to an Existing List</h5>
                <p>
                  If you've already created a list, now you can select patients individually to add to an existing list.Once you've selected patients you'd like to add to an existing list, click the "Add to Existing List" button
                </p>
            </b-card>
            <b-card class="mb-xlg border-0" :style="{ position: 'relative' }"
              :img-src="list2" img-alt="Card image" img-bottom
              >
                <p>Just select from the drop-down a list you've already created to add the selected patients to:</p>
            </b-card>
          </b-col>

          <b-col xs='12' sm='6' md='4'>
           <b-card class="mb-xlg border-0" :style="{ position: 'relative' }"
           :img-src="patientSearch" img-alt="Patient Search" img-bottom
           >
           
                <h5 class="fw-semi-bold ml-4">New Feature</h5>
              
                <b-badge class="mt-lg fw-thin rounded-0" variant="success"
                  :style="{ position: 'absolute', top: 0, left: 0 }">New</b-badge>
                <hr />
                <h5 class="text-success fw-semi-bold">Patient Search with Auto-suggest</h5>
                <p>
                  Quickly search through your patient database with Auto-suggest. So instead of typing in the entire patient's name, you can start to type the first few letters of their first name or last name - press enter and you'll quickly be taken to their Patient Profile page.
                </p>
                </b-card>
           
          </b-col>
        
        </b-row>
        <b-card no-body :style="{ background: 'transparent', border:0 }">
            <hr />
        </b-card>
        <b-row class="mt-4">
           <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                June 9, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <ul class="bug-fixes">
                <li><p>Fixed a bug where even if the attempt was not allowed and the "Add Attempt" button was grayed out, user was still able to click on the button.</p></li>
                <li><p>Optimized the backend query to pull Scheduled Data for Team Insights so the page loads MUCH faster than it used to when there's actual tasks data that spans weeks to a month!: Data loads about 42x FASTER!!</p></li>
              </ul>
            
            </b-card>
          </b-col>
          <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                June 5, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <ul class="bug-fixes">
                <li><p>Fixed a bug where an employee not assigned specific task was able to make an attempt through the Team Dashboard. Did this for the following Pages: Overdue Recall, Unscheduled Treatment, Outstanding Claims, Outstanding Pre-Auths, Processed Pre-Auths, Patient Balances and Broken Appointments.</p></li>
                <li><p>Following the above, added correct router links to Patient Names displayed on the Team Dashboard, so the user ends up on the correct page.</p></li>
              </ul>
            
            </b-card>
          </b-col>
          <b-col xs='12' sm='6' md='4'>
            <b-card class="border-0">
              <h4 class="mb mt-xs fw-semi-bold">
                June 3, 2020
              </h4>
              <hr />
              <h5 class="fw-semi-bold">Bug fixes & improvements:</h5>
              <ul class="bug-fixes">
                <li><p>Fixed a bug where on the Overdue Recall Settings page, an error was occuring when changing the accountable person.</p></li>
                <li><p>Fixed a bug where if someone goes to a page directly (having logged in before) it wasn't loading the navigation properly</p></li>
                <li><p>Fixed a bug where there was a timeout issue due to the amount of data being processed for Aging page, especially for developing the Pie Charts showing the 30-60-90 day Aging $$$.</p></li>
              </ul>
            
            </b-card>
          </b-col>
        </b-row>
 </div>
    
</template>


<script>
import Widget from '@/components/Widget/Widget';

import list1 from '../../assets/List1.png';
import list2 from '../../assets/list2.png';
import patientSearch from '../../assets/opendental-patient-search.png';
import teamInsightsCustomReportsFilter from '../../assets/team-insights-custom-reports-filter.png';
import patientBillingFilter from '../../assets/patient-billing-filter.png';
import customReports1 from '../../assets/custom-reports-1.png';
import teamInsightsCustomReportsUnscheduled from '../../assets/team-insights-custom-reports-unscheduled.png';
import deletePatientCustomList from '../../assets/delete-patient-custom-list.png';
import notSetFollowUp from '../../assets/not-set-follow-up.png';
import frequencyFeature from '../../assets/preventive-frequency.gif';
import initiateFromProfile from '../../assets/initiate-fu-from-profile.gif';
import existingFromProfile from '../../assets/patient-profile-fu-1536x760.png';
import taskPage from '../../assets/task-page.png';
import taskDetails from '../../assets/task-details.png';
import deletePatient from '../../assets/delete-patient.png';
import teamioHowTo from '../../assets/teamio-how-to.png';





export default {
  name: 'Card',
  components: { Widget },
  data() {
    return {
      list1,
      list2,
      patientSearch,
      teamInsightsCustomReportsFilter,
      patientBillingFilter,
      customReports1,
      teamInsightsCustomReportsUnscheduled,
      deletePatientCustomList,
      notSetFollowUp,
      frequencyFeature,
      initiateFromProfile,
      existingFromProfile,
      taskPage,
      taskDetails,
      deletePatient,
      teamioHowTo,
      
      
  }
}
}
</script>

<style lang="scss">
ul.bug-fixes {
  list-style-type: square;
  padding:10px;
}

ul.bug-fixes li {
    margin-left:10px;
    margin-top:5px;
    margin-bottom:10px;
}
</style>